export default __webpack_public_path__ + "static/media/b31-graphics.30ce4c68.png";